import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoardDemoPanelComponent } from './board-demo-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { RecaptchaModule } from "ng-recaptcha";


@NgModule({
  declarations: [BoardDemoPanelComponent],
  exports: [BoardDemoPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    RecaptchaModule
  ],
})
export class BoardDemoPanelModule { }
